/**
 * Segment used in the public eshop buy URL.
 * Prefer the last ref id (Eshop resolves refs as well as UUIDs).
 */
export function screeningEshopBuyId(screening) {
    const refs = Array.isArray(screening?.refs) ? screening.refs : [];
    for (let i = refs.length - 1; i >= 0; i--) {
        const ref = refs[i];
        const raw = typeof ref === 'string' ? ref : ref?.id;
        const id = typeof raw === 'string' ? raw.trim() : '';
        if (id)
            return id;
    }
    return screening?._id || '';
}

export function screeningEshopBuyUrl(eshopUri, screening) {
    const base = String(eshopUri || '').replace(/\/$/, '');
    const id = screeningEshopBuyId(screening);
    if (!base || !id)
        return '';
    return `${base}/screening/buy/${encodeURIComponent(id)}`;
}
